<script setup lang="ts">
defineProps<{ resetKey: string; login: string }>();
</script>

<template>
  <UiDefaultPage title="Définir un nouveau mot de passe">
    <div class="flex max-w-screen-sm flex-col gap-6 rounded-lg border bg-light p-6 shadow-lg">
      <h3 class="h4">
        Veuillez saisir un nouveau mot de passe:
      </h3>
      <AuthResetPasswordForm :reset-key="resetKey" :login="login" />
    </div>
  </UiDefaultPage>
</template>
